import React, { useContext, useEffect, useState } from "react";
import { TMDataContext } from "../utils/custom_hooks/TMDataContext";
import { GoalActivationContainer } from "./modals/goalActivationContainer";
import { GoalDeactivationContainer } from "./modals/goalDeactivationContainer";
import { GoalTemplateReloadContainer } from "./modals/goalTemplateReloadContainer";

export const ModalContainer = ({ selection }) => {
  const { modalStatus, setModalStatus } = useContext(TMDataContext);

  useEffect(() => {
    if (modalStatus != "closed") {
      $("#patient-referrals-form").prepend(
        "<div id='patient-goal-modal-screen'></div>"
      );
    } else {
      $("#patient-goal-modal-screen").remove();
    }
  }, [modalStatus]);

  const closeModal = () => {
    setModalStatus("closed");
  };

  const renderModal = () => {
    if (modalStatus == "closed") return null;

    switch (modalStatus) {
      case "reload":
        return <GoalTemplateReloadContainer closeModal={closeModal} />;

      case "activate":
        return (
          <GoalActivationContainer
            selection={selection}
            closeModal={closeModal}
          />
        );
        break;
      case "deactivate":
        return (
          <GoalDeactivationContainer
            selection={selection}
            closeModal={closeModal}
          />
        );
        break;
      case "restore":
        return (
          <GoalActivationContainer
            selection={selection}
            closeModal={closeModal}
          />
        );
        break;
      case "remove":
        return (
          <GoalDeactivationContainer
            selection={selection}
            closeModal={closeModal}
          />
        );
    }
  };
  return <>{renderModal()}</>;
};
